import React, {forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState} from "react";
import {Input, Modal} from "antd";
import {IconCloseBlack} from "../Icon";
import {t} from "i18next";
import {postMessage} from "./event";
import {EVENT_RENAME_PAGES} from "../Const";
import {noteServer} from "./notesServer";
import global from "@/global";
import {KEYS} from "../../@excalidraw/packages/excalidraw/keys";

let mOnCallback:any;
const DialogCommonInput = forwardRef((props, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog,
        onShowDialogAll:onShowDialogAll,
        onCloseDialog:onCloseDialog
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [inputValue,setInputValue] = useState('');
    const [title,setTitle] = useState(t("Name"));
    const [cancelText,setCancelText] = useState(t("Cancel"));
    const [okText,setOkText] = useState(t("Modify"));
    const [placeHolder,setPlaceHolder] = useState('');
    const inputRef = useRef(null);

    const inputValueRef = useRef(inputValue);

    const onShowDialog = (szInputValue:string,onCallback:any)=>{
        mOnCallback = onCallback;
        setInputValue(szInputValue);
        setIsShowDialog(true);
    }

    const onShowDialogAll = (szInputValue:string,szTitle:string,szCancel:string,szOk:string,onCallback:any,szPlaceHolder='')=>{
        mOnCallback = onCallback;
        setInputValue(szInputValue);
        setTitle(szTitle);
        setCancelText(szCancel);
        setOkText(szOk);
        setPlaceHolder(szPlaceHolder)
        setIsShowDialog(true);
    }

    const onCloseDialog = ()=>{
        setIsShowDialog(false);
    }


    return (
        <Modal
            afterOpenChange={(e)=>{
                inputRef?.current?.focus();
                global.g_showDialogs.dialogInfos = e;
            }}
            zIndex={99999}
            width={'468px'}
            footer={''}
            open={isShowDialog}
            centered={true}
            onCancel={()=>setIsShowDialog(false)}
            closeIcon={<IconCloseBlack/>}
        >
            <div className={'flex-col'}>
                <span className={'dialog-title'}>{title}</span>
                <div className='line' style={{margin: '12px -22px'}}></div>
                <Input variant={'borderless'} className={'input-border mt-10'} placeholder={placeHolder} ref={inputRef} value={inputValue}
                       onChange={(e) => setInputValue(e.target.value)} onKeyDown={(event)=>{
                           if (event.key == KEYS.ENTER) {
                               if (inputValue.trim() === "") {
                                   return noteServer.openTip("error", t("Please input name"));
                               }
                               if (mOnCallback) {
                                   mOnCallback(inputValue);
                               }
                           }
                }}/>
                <div className={'flex-center'} style={{marginTop: '20px'}}>
                    <div className={'button-border-gray-style flex-center'} style={{minWidth: '164px', height: '38px'}} onClick={()=>{
                        setIsShowDialog(false);
                    }}>
                        <span>{cancelText}</span>
                    </div>
                    <div className='flex-center button-solid-style ml-10'
                         style={{minWidth: '164px', height: '38px', alignSelf: 'center'}}
                         onClick={() => {
                             if (inputValue.trim() === "") {
                                 return noteServer.openTip("error", t("Please input name"));
                             }
                             if (mOnCallback) {
                                 mOnCallback(inputValue);
                             }
                         }}>
                        <span className='ml-6 font-family-medium'>{okText}</span>
                    </div>
                </div>
            </div>

        </Modal>
    );
})

export default DialogCommonInput;